import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { Section } from 'foundations-components/transitional/components/Section';
import PlanCompatibilityFilter from 'marketplace-ui-common/filters/components/PlanCompatibilityFilter';
import BusinessTypeFilter from './BusinessTypeFilter';
import FreeSupportFilter from './FreeSupportFilter';
import ModuleCategoryFilter from './ModuleCategoryFilter';
import PageFeatureFilter from './PageFeatureFilter';
import PageTypeFilter from './PageTypeFilter';
import PriceFilter from './PriceFilter';
import ProviderFilter from './ProviderFilter';
import RatingFilter from './RatingFilter';
import SearchTagFilter from './SearchTagFilter';
import OfferingTypeFilter from './OfferingTypeFilter';
// @ts-expect-error untyped module
import { useEmbedContext } from '../../../hooks/useEmbedContext';
import { getIsInApp } from '../../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function AssetFilterFields({
  filters,
  isFilterDisabled,
  onFilterChange
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  if (!isEmbedded && filters.search) {
    if (filters.offeringTypes) {
      if (filters.offeringTypes.includes('THEME')) {
        return /*#__PURE__*/_jsx(ThemeFilterFields, {
          filters: filters,
          isFilterDisabled: isFilterDisabled,
          onFilterChange: onFilterChange
        });
      } else if (filters.offeringTypes.includes('MODULE')) {
        return /*#__PURE__*/_jsx(ModuleFilterFields, {
          filters: filters,
          isFilterDisabled: isFilterDisabled,
          onFilterChange: onFilterChange
        });
      }
    }
    return /*#__PURE__*/_jsx(UnifiedSearchFilterFields, {
      filters: filters,
      isFilterDisabled: isFilterDisabled,
      onFilterChange: onFilterChange
    });
  }
  if ('businessTypes' in filters) return /*#__PURE__*/_jsx(ThemeFilterFields, {
    filters: filters,
    isFilterDisabled: isFilterDisabled,
    onFilterChange: onFilterChange
  });else return /*#__PURE__*/_jsx(ModuleFilterFields, {
    filters: filters,
    isFilterDisabled: isFilterDisabled,
    onFilterChange: onFilterChange
  });
}
function UnifiedSearchFilterFields({
  filters,
  isFilterDisabled = () => false,
  onFilterChange
}) {
  return (
    /*#__PURE__*/
    /* @ts-expect-error _size is an available prop, but not included in types */
    _jsxs(Fieldset, {
      _size: "small",
      children: [filters.search && /*#__PURE__*/_jsx(OfferingTypeFilterField, {
        filters: filters,
        onFilterChange: onFilterChange
      }), /*#__PURE__*/_jsx(AssetBaseFilterFields, {
        filters: filters,
        isFilterDisabled: isFilterDisabled,
        offeringType: filters.offeringTypes.length ? filters.offeringTypes : ['MODULE', 'THEME'],
        onFilterChange: onFilterChange
      })]
    })
  );
}
function ThemeFilterFields({
  filters,
  isFilterDisabled = () => false,
  onFilterChange
}) {
  return (
    /*#__PURE__*/
    /* @ts-expect-error _size is an available prop, but not included in types */
    _jsxs(Fieldset, {
      _size: "small",
      children: [filters.search && /*#__PURE__*/_jsx(OfferingTypeFilterField, {
        filters: filters,
        onFilterChange: onFilterChange
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(AccordionItem, {
          defaultOpen: true,
          title: /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.assets.filters.businessType.title"
            })
          }),
          children: /*#__PURE__*/_jsx(BusinessTypeFilter, {
            disabled: isFilterDisabled('businessTypes'),
            onChange: event => onFilterChange('businessTypes', event.target.value),
            value: filters.businessTypes
          })
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(AccordionItem, {
          defaultOpen: true,
          title: /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.assets.filters.pageTypes.title"
            })
          }),
          children: /*#__PURE__*/_jsx(PageTypeFilter, {
            disabled: isFilterDisabled('pageTypes'),
            onChange: event => onFilterChange('pageTypes', event.target.value),
            value: filters.pageTypes
          })
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(AccordionItem, {
          defaultOpen: true,
          title: /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.assets.filters.pageFeatures.title"
            })
          }),
          children: /*#__PURE__*/_jsx(PageFeatureFilter, {
            disabled: isFilterDisabled('pageFeatures'),
            onChange: event => onFilterChange('pageFeatures', event.target.value),
            value: filters.pageFeatures
          })
        })
      }), /*#__PURE__*/_jsx(AssetBaseFilterFields, {
        filters: filters,
        isFilterDisabled: isFilterDisabled,
        offeringType: "THEME",
        onFilterChange: onFilterChange
      })]
    })
  );
}
function ModuleFilterFields({
  filters,
  isFilterDisabled = () => false,
  onFilterChange
}) {
  return (
    /*#__PURE__*/
    /* @ts-expect-error _size is an available prop, but not included in types */
    _jsxs(Fieldset, {
      _size: "small",
      children: [filters.search && /*#__PURE__*/_jsx(OfferingTypeFilterField, {
        filters: filters,
        onFilterChange: onFilterChange
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(AccordionItem, {
          defaultOpen: true,
          title: /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.assets.filters.categories.title"
            })
          }),
          children: /*#__PURE__*/_jsx(ModuleCategoryFilter, {
            disabled: isFilterDisabled('categories'),
            onChange: event => onFilterChange('categories', event.target.value),
            value: filters.categories
          })
        })
      }), /*#__PURE__*/_jsx(AssetBaseFilterFields, {
        filters: filters,
        isFilterDisabled: isFilterDisabled,
        offeringType: "MODULE",
        onFilterChange: onFilterChange
      })]
    })
  );
}
function AssetBaseFilterFields({
  filters,
  isFilterDisabled = () => false,
  offeringType = 'THEME',
  onFilterChange
}) {
  const isInApp = useSelector(getIsInApp);
  const appContext = isInApp ? 'app' : 'public';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(AccordionItem, {
        defaultOpen: true,
        title: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.assets.filters.portalCompatible.title"
          })
        }),
        children: /*#__PURE__*/_jsx(PlanCompatibilityFilter, {
          appContext: appContext,
          ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.portalCompatible.title'),
          onChange: event => {
            const {
              portalCompatible,
              tiers
            } = event.target.value;
            onFilterChange('portalCompatible', portalCompatible);
            onFilterChange('tiers', tiers);
          },
          value: {
            portalCompatible: !!filters.portalCompatible,
            tiers: filters.tiers
          },
          validTierGroups: ['CRM', 'MARKETING', 'CMS']
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(AccordionItem, {
        defaultOpen: true,
        title: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.assets.filters.price.title"
          })
        }),
        children: /*#__PURE__*/_jsx(PriceFilter, {
          disabled: isFilterDisabled('planType'),
          onPlanTypeChange: (field, value) => onFilterChange(field, value),
          onPriceRangeChange: (field, value) => onFilterChange(field, value),
          planTypeValue: filters.planType,
          priceRangeValue: filters.priceRange
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(AccordionItem, {
        defaultOpen: true,
        title: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.assets.filters.rating.title"
          })
        }),
        children: /*#__PURE__*/_jsx(RatingFilter, {
          disabled: isFilterDisabled('minOverallRating'),
          onChange: (field, value) => onFilterChange(field, value),
          value: filters.minOverallRating
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(AccordionItem, {
        defaultOpen: true,
        title: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.assets.filters.support.title"
          })
        }),
        children: /*#__PURE__*/_jsx(FreeSupportFilter, {
          checked: !!filters.hasFreeSupport,
          disabled: isFilterDisabled('hasFreeSupport'),
          onChange: (field, event) => onFilterChange(field, event.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(AccordionItem, {
        defaultOpen: true,
        title: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.assets.filters.providers.title"
          })
        }),
        children: /*#__PURE__*/_jsx(ProviderFilter, {
          disabled: isFilterDisabled('providers'),
          offeringType: offeringType,
          onChange: event => onFilterChange('providers', event.target.value),
          value: filters.providers
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(AccordionItem, {
        defaultOpen: true,
        title: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.assets.filters.searchTags.title"
          })
        }),
        children: /*#__PURE__*/_jsx(SearchTagFilter, {
          disabled: isFilterDisabled('tags'),
          offeringType: offeringType,
          onChange: event => onFilterChange('tags', event.target.value),
          value: filters.tags
        })
      })
    })]
  });
}
function OfferingTypeFilterField({
  filters,
  onFilterChange
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  if (isEmbedded) {
    return null;
  }
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsx(AccordionItem, {
      defaultOpen: true,
      title: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.assets.filters.offeringType.title"
        })
      }),
      children: /*#__PURE__*/_jsx(OfferingTypeFilter, {
        onChange: (field, value) => onFilterChange(field, value),
        value: filters.offeringTypes
      })
    })
  });
}